module.exports = __webpack_public_path__ + "img/instagram.3024813a.png";